/**
 * Constantes y mapeos para gestión de Leads
 */

// Mapeo de etapas del pipeline a texto legible
export const STAGE_LABELS = {
  'Nuevo Prospecto': 'Nuevo Prospecto',
  'Cita Agendada': 'Cita Agendada',
  'Cita Realizada': 'Cita Realizada',
  'Propuesta Presentada': 'Propuesta Presentada',
  'Solicitud Ingresada': 'Solicitud Ingresada',
  'Perdido': 'Perdido',
  'Ganado': 'Ganado'
};

// Mapeo de tipos de actividad a texto legible
export const ACTIVITY_TYPE_LABELS = {
  'created': '📝 Creado',
  'stage_change': '🔄 Cambio de Etapa',
  'note': '📌 Nota',
  'call': '📞 Llamada',
  'meeting': '🤝 Reunión',
  'email': '✉️ Email',
  'converted': '🎉 Convertido a Cliente'
};

// Mapeo de fuentes del lead
export const SOURCE_LABELS = {
  'Referido': 'Referido',
  'Sitio Web': 'Sitio Web',
  'Facebook': 'Facebook',
  'Instagram': 'Instagram',
  'WhatsApp': 'WhatsApp',
  'Llamada Telefónica': 'Llamada',
  'Visita Directa': 'Visita',
  'Otro': 'Otro'
};

// Mapeo de prioridades
export const PRIORITY_LABELS = {
  'Alta': 'Alta',
  'Media': 'Media',
  'Baja': 'Baja'
};

// Colores para prioridades
export const PRIORITY_COLORS = {
  'Alta': 'bg-red-100 text-red-800',
  'Media': 'bg-yellow-100 text-yellow-800',
  'Baja': 'bg-gray-100 text-gray-800',
};

// Función auxiliar para formatear descripción de cambio de etapa
export const formatStageChangeDescription = (description) => {
  // Si la descripción tiene el formato "Movido de 'X' a 'Y'"
  const match = description.match(/Movido de '(.+?)' a '(.+?)'/);
  if (match) {
    const fromStage = match[1];
    const toStage = match[2];
    return `Movido de ${STAGE_LABELS[fromStage] || fromStage} a ${STAGE_LABELS[toStage] || toStage}`;
  }
  return description;
};
